module.exports = __webpack_public_path__ + "static/media/client1.f49972bb.jpg";